import type { AccountPlatformType, AccountType } from "shared/types/accounts";

export function filterPostFormPickerAccounts(
  accounts: AccountType[],
  platforms?: AccountPlatformType[]
): AccountType[] {
  if (!platforms?.length) return accounts;
  return accounts.filter((account) =>
    platforms.includes(account.platformType || "IG")
  );
}

export function resolvePostFormPickerSelection(
  accounts: AccountType[],
  selectedIds: string[]
): AccountType[] {
  const selected = new Set(selectedIds);
  return accounts.filter((account) => selected.has(account._id));
}
